import {
  CheckboxInput,
  FormContainer,
  Input,
  RichTextField,
} from "../../components/inputs";
import { Field, Form } from "react-final-form";
import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "../../components/button";
import { Grid } from "../../components/section";
import { Text } from "../../components/typography";
import styled from "styled-components";

export const AwardsForm = (props) => {
  const { onFormSubmit, initialValues } = props;

  const navigate = useNavigate();
  const location = useLocation();

  const onSubmit = (values) => {
    onFormSubmit(values);
  };

  const onCloseandReset = (reset) => {
    reset();

    const direction = location.pathname.split("/").includes("edit")
      ? navigate(-1, { replace: true })
      : navigate("/", { replace: true });
    return direction;
  };

  return (
    <Form onSubmit={onSubmit} initialValues={initialValues}>
      {({ handleSubmit, pristine, submitting, invalid, form: { reset } }) => (
        <form onSubmit={handleSubmit}>
          <Grid col="l15">
            <div>
              <FormContainer>
                <Field
                  name="title"
                  type="text"
                  component={Input}
                  label="Title"
                  placeholder="What is the award name?"
                />
              </FormContainer>
              <FormContainer>
                <Field
                  name="description"
                  label="Describe the award."
                  component={RichTextField}
                />
              </FormContainer>
              <FormContainer>
                <Grid>
                  <Field
                    label="Featured"
                    name="featured"
                    type="checkbox"
                    component={CheckboxInput}
                  />
                </Grid>
              </FormContainer>
            </div>
          </Grid>
          <ButtonFlex>
            <Text scale="small" onClick={() => onCloseandReset(reset)}>
              Cancel
            </Text>
            <Button
              type="submit"
              disabled={submitting || pristine || invalid}
              text={submitting ? "Saving..." : "Save"}
            />
          </ButtonFlex>
        </form>
      )}
    </Form>
  );
};
const ButtonFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  a:link,
  p,
  button {
    margin: 0;
    cursor: pointer;
  }
`;
